import { withTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import userLogo from "../../assets/jobSeeker.png";
import "./styles.css";

const Index = ({ data, key }) => {
  const navigate = useNavigate();
  const handleClick = () => {
    navigate(`/employer/profile/${data.key}`);
  };
  return (
    <div
      className="d-flex p-3 flex-column align-items-center shadow-sm bg-white mb-3 recentJobSeeker"
      key={key}
      onClick={handleClick}
    >
      <img
        src={data?.logo || userLogo}
        width="120px"
        height="120px"
        className="rounded-circle"
        style={{ border: "1px solid rgb(0,0,0,0.2)", padding: "2px" }}
      />
      <h6 className="text-info mt-2 mb-0 text-center">{data?.name}</h6>
      <p style={{ fontSize: "12px", margin:'0px', color:'rgb(0,0,0,0.5)' }}>{data?.title}</p>
    </div>
  );
};
export default withTranslation()(Index);
